/* eslint-disable no-unused-vars */
// eslint-disable-next-line no-shadow
enum EProcesoFondeo {
  FONDEO = 'Fondeo',
  FONDEO_POR_TARJETA_PREPAGA = 'Fondeo por tarjeta prepaga',
  TRANSFERENCIA_RECIBIDA_DEL_USUARIO_X = 'Transferencia recibida del usuario ',
}

export default EProcesoFondeo;
